import classNames from 'classnames';
import React from 'react';

import { ItemIconProps } from '../../../../components/templates/SideBarWrapper/SideBarWrapper.types';
import { replaceSizeWithViewBoxInSVG } from '../../../../helpers/image';
import { serviceTypes } from '../../../config';

// TODO possible duplicate of ItemIcon in SIdebarWrapper/ItemIcon.tsx
const ItemIcon = ({
  service,
  customIcons,
  withoutWrapper = false,
  className = 'nav-item-icon',
}: ItemIconProps) => {
  const itemIcon = customIcons[service.navigation.name];

  if (itemIcon) {
    return (
      <div
        className={classNames(className)}
        dangerouslySetInnerHTML={{ __html: replaceSizeWithViewBoxInSVG(itemIcon) }}
      />
    );
  }

  if (serviceTypes[service.name].icon) {
    if (withoutWrapper) {
      return serviceTypes[service.name].icon || <></>;
    }

    return <div className={classNames(className)}>{serviceTypes[service.name].icon}</div>;
  }

  return <></>;
};

export default ItemIcon;
